// @ts-strict-ignore
import { DropdownItem } from 'reactstrap';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section, Origin } from 'src/constants/footfall';
import { setPostPrivate } from 'src/modules/community/write/actions';
import ButtonDropdown from 'src/components/buttons/buttonDropdown';
import { StyledIconButton } from 'src/modules/community/write/components/sharedStyles';
const postPrivacy = {
  community: i18n.t('Community only'),
  anyone: i18n.t('Anyone')
};
export default function PrivacySection(): JSX.Element {
  const dispatch = useDispatch();
  const {
    isPostPrivate,
    post
  } = useSelector(state => state.pages.write);
  const {
    isPrivate
  } = useSelector(state => state.context.currentCommunity);
  if (isPrivate) return null; // Don't display for a private community

  const showCommunityPrivacyInfo = () => {
    helpScoutArticle('191-who-can-see-my-post');
    trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.PostShareWithPrivacyInfo,
        origin: post?.id ? Origin.EditPostPage : Origin.WritePostPage
      },
      clickType: 'viewed'
    });
  };
  const changePostPrivacy = (isSetPrivate: boolean) => {
    dispatch(setPostPrivate(isSetPrivate));
    trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.PostShareWith,
        origin: post?.id ? Origin.EditPostPage : Origin.WritePostPage
      },
      clickType: `share-with-${isSetPrivate ? 'community-only' : 'anyone'}`
    });
  };
  return <PrivacyWrapper data-sentry-element="PrivacyWrapper" data-sentry-component="PrivacySection" data-sentry-source-file="writePostPrivacySection.tsx">
      <PrivacyOption data-testid="write-privacy-option" data-sentry-element="PrivacyOption" data-sentry-source-file="writePostPrivacySection.tsx">
        <div>{i18n.t('Share:')}</div>
        <PrivacySelect ariaLabel={i18n.t('Select post privacy')} color="grey" dataTestId="post-privacy-select" text={isPostPrivate ? postPrivacy.community : postPrivacy.anyone} data-sentry-element="PrivacySelect" data-sentry-source-file="writePostPrivacySection.tsx">
          <DropdownItem aria-label={i18n.t('Select anyone')} data-testid="anyone-button" onClick={() => changePostPrivacy(false)} data-sentry-element="DropdownItem" data-sentry-source-file="writePostPrivacySection.tsx">
            {postPrivacy.anyone}
          </DropdownItem>
          <DropdownItem aria-label={i18n.t('Select community-only')} data-testid="community-only-button" onClick={() => changePostPrivacy(true)} data-sentry-element="DropdownItem" data-sentry-source-file="writePostPrivacySection.tsx">
            {postPrivacy.community}
          </DropdownItem>
        </PrivacySelect>
        <StyledIconButton ariaLabel={i18n.t('Who can see my post?')} dataTestId="privacy-info-button" icon="information" type="link" onClick={showCommunityPrivacyInfo} data-sentry-element="StyledIconButton" data-sentry-source-file="writePostPrivacySection.tsx" />
      </PrivacyOption>
    </PrivacyWrapper>;
}
const PrivacySelect = styled(ButtonDropdown)`
  padding-left: 5px;
`;
const PrivacyOption = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const PrivacyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 0 0;
`;